import { Typography } from '@mui/material';
import React from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

const LocationSearch = ({  label,value, onChange, placeholder = 'Select Location', width }) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  return (
    <div>
      <Typography variant="body2" sx={{ fontSize: '14px', fontWeight: 500, color: 'text.main', mb: 0.8 }}>{label}</Typography>
      <GooglePlacesAutocomplete
        apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        selectProps={{
          value,
          onChange: handleChange,
          placeholder: placeholder,
          styles: {
            control: (provided, state) => ({
              ...provided,
              width: width || '465px',
              maxWidth: width || '465px',
              fontSize: '14px',
              borderRadius: '8px',
              border: state.isFocused ? '1px solid #ccc' : '1px solid #ccc', // Custom border on focus
              boxShadow: state.isFocused ? 'none' : 'none', // Remove box shadow on focus
              '&:hover': {
                border: '1px solid #ccc', // Keep same border on hover
              }
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isFocused ? '#f5f5f5' : 'white',
              color: '#333',
              '&:active': {
                backgroundColor: '#e8e8e8',
              }
            }),
          },
        }}
        autocompletionRequest={{
          componentRestrictions: {
            country: ['us'],
          },
        }}
        onLoadFailed={(error) => 
          console.error('Could not inject Google script', error)
        }
      />
    </div>
  );
};

export default LocationSearch;